module.exports = __webpack_public_path__ + "static/bg-area-6a49b33348dfba2c68599611db3a9b3f.png";